/**
 * Temperature conversion utilities.
 * Default: Fahrenheit. Toggle: Celsius.
 * Convert locally — never refetch from API.
 */

export function cToF(c) {
  if (c == null || c === '') return null;
  return Math.round((c * 9 / 5) + 32);
}

export function fToC(f) {
  if (f == null || f === '') return null;
  return Math.round((f - 32) * 5 / 9);
}

/**
 * Format temperature for display.
 * @param {number} celsius - Temperature in Celsius (API always sends C)
 * @param {string} unit - 'F' or 'C'
 * @returns {string} Formatted string like "77°F" or "25°C"
 */
export function formatTemp(celsius, unit = 'F') {
  if (celsius == null || celsius === '') return '--';
  if (unit === 'C') return `${Math.round(celsius)}\u00B0C`;
  return `${cToF(celsius)}\u00B0F`;
}

/**
 * Get unit from localStorage, default to F.
 */
export function getSavedUnit() {
  try {
    return localStorage.getItem('nova_temp_unit') || 'F';
  } catch {
    return 'F';
  }
}

export function saveUnit(unit) {
  try {
    localStorage.setItem('nova_temp_unit', unit);
  } catch {}
}
